<div class="staging-preview-banner" *ngIf="isStaging" role="status">
  <strong>PREVIEW PAGE</strong>
  <span>Staging mode is active. Transactions and payments on this site are for preview only and will not be treated as live production transactions.</span>
</div>

<router-outlet></router-outlet>
<!-- <app-widget-tell-budget/> -->
